/* istanbul ignore file */

export enum NotificationCadence {
    Immediate = 1,
    Daily = 2,
    Weekly = 3
}
